export enum Currency {
  Eur = "Eur",
  Mad = "Mad",
  Usd = "Usd",
  Gbp = "Gbp",
  Chf = "Chf",
}

export enum LanguageKey {
  FR = "fr",
  EN = "en",
  DE = "de",
  NL = "nl",
}

export interface Language {
  key: LanguageKey;
  name: string;
  flag: string;
}

export const Languages: Record<LanguageKey, Language> = {
  [LanguageKey.FR]: {
    key: LanguageKey.FR,
    name: "Français",
    flag: "/img/flag/fr.svg",
  },
  [LanguageKey.EN]: {
    key: LanguageKey.EN,
    name: "English",
    flag: "/img/flag/en.svg",
  },
  [LanguageKey.DE]: {
    key: LanguageKey.DE,
    name: "Deutschland",
    flag: "/img/flag/de.svg",
  },
  [LanguageKey.NL]: {
    key: LanguageKey.NL,
    name: "Nederland",
    flag: "/img/flag/nl.svg",
  },
};